import styled from 'styled-components';

import './product.css';

import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import {
	currentTransState,
	percomaticLoadedState,
	transItemState
} from '../../../atoms';
import { useUpdateCartItem } from '../../../Cart/hooks/useUpdateCartItem';
import { useEditTransItem } from '../../../Cart/hooks/api';
import UI from '../../../domains/UI';
import { useActiveOrder } from '../../../Order/hooks/useActiveOrder';
import { transItemProductState } from '../../atoms';
import { ProductBody } from '../../components/ProductBody';
import { ProductHeader } from '../../components/ProductHeader';
import { ProductSkeleton } from '../../components/ProductSkeleton';
import {
	OrderItemFieldsFragment,
	useProductImageLazyQuery
} from '../../graphql';

export const Edit: React.FC = () => {
	const navigate = useNavigate();
	const params = useParams();
	useUpdateCartItem();
	const percomaticLoaded = useRecoilValue(percomaticLoadedState);
	const [activeOrderId, { order }] = useActiveOrder();

	const product = useRecoilValue(transItemProductState);
	const [productId, setProductId] = useState<number>();

	const [productImageQuery, { data, error }] = useProductImageLazyQuery();
	UI.actions.useApolloError(error);

	const currentTrans = useRecoilValue(currentTransState);
	const editTransItem = useEditTransItem();
	const transItem = useRecoilValue(transItemState);

	// Checks after placed the order, Product can be editable or not
	const isEditable =
		activeOrderId &&
		order?.items.some(
			(item: OrderItemFieldsFragment) => item.id === params.id
		);

	useEffect(() => {
		if (product?.id) {
			setProductId(product.id);
		}
	}, [product?.id]);

	useEffect(() => {
		if (productId) {
			productImageQuery({ variables: { productId: String(productId) } });
		}
	}, [productId, productImageQuery]);

	useEffect(() => {
		if (
			!params.id ||
			!percomaticLoaded ||
			!currentTrans ||
			transItem?.id === params.id
		)
			return;

		const index = currentTrans.items.findIndex(
			transItem => transItem.id === params.id
		);

		if (isEditable) {
			navigate(-1);
		} else if (index > -1) {
			editTransItem(index);
		} else {
			navigate('/');
		}
	}, [
		navigate,
		currentTrans,
		editTransItem,
		percomaticLoaded,
		params.id,
		transItem?.id,
		isEditable
	]);

	return (
		<Container>
			{percomaticLoaded ? (
				<>
					<Content>
						<ProductHeader />
					</Content>

					<Content>
						<ProductBody autoModify={data?.product?.autoModify} />
					</Content>
				</>
			) : (
				<ProductSkeleton />
			)}
		</Container>
	);
};

const Container = styled.div`
	max-width: 1140px;
	width: 100%;
	display: flex;
	flex-direction: row;
	column-gap: 24px;

	@media (max-width: 768px) {
		flex-direction: column;
		row-gap: 24px;
		column-gap: unset;
	}
`;

const Content = styled.div`
	width: 50%;

	@media (max-width: 768px) {
		width: 100%;
	}
`;
